// ui/sidebar writes this cookie on every toggle but never reads it back.
export const readSidebarOpen = (cookie: string): boolean => {
  const match = cookie.match(/(?:^|;\s*)sidebar_state=(true|false)/);
  return match ? match[1] === "true" : true;
};
